import { connect } from 'react-redux';
import WithResizeScreen, { SCREEN_MODES } from '../../../common/components/WithResizeScreen/WithResizeScreen';
import { BUTTON, Button } from '../../../components/common/Button/Button';
import MyTasks from '../TasksV4/MyTasks';
import { Box } from '@material-ui/core';
import { VIEWS } from '../../constants/newInbox';
import styles from './NewInbox.scss';
import newInboxActions from '../../actions/newInbox';


const MobileMyTaskV4 = ({ tasksForMultiSign, changeView, currentView, screenMode }) => {
    return (
        <Box style={{ position: 'relative', height: screenMode == SCREEN_MODES.TABLET ? 'calc(100% - 50px)' : '100%' }}>
            <Box style={{ height: tasksForMultiSign.length ? 'calc(100% - 60px)' : '100%' }}>
                <MyTasks status='pending' isMobileView={true} />
            </Box>
            <Box className={[styles.taskFooterContainer, !tasksForMultiSign.length || [VIEWS.TASK_SIGNATURE, VIEWS.DOCUMENT_DETAIL].includes(currentView) ? styles.taskFooterContainerNoHeight : {}]}>
                <Box className={styles.taskSignFooter}>
                    <Button
                        variant="fill"
                        className={styles.primaryBtn}
                        bgcolor={BUTTON.BGCOLOR.BLUE}
                        color={BUTTON.COLOR.WHITE}
                        onClick={() => changeView(VIEWS.TASK_SIGNATURE)}
                    >Sign All Selected ({tasksForMultiSign.length})</Button>
                </Box>
            </Box>
        </Box>
    );
};

const mapStateToProps = state => ({
    tasksForMultiSign: state.tasksForMultiSign || [],
    currentView: state.view || null,

});

const mapDispatchToProps = {
    changeView: newInboxActions.changeView,

};

export default connect(mapStateToProps, mapDispatchToProps)(WithResizeScreen(MobileMyTaskV4));